var heading_default = {
  "fontElementMap": "Ku00u",
  "elementSpacing": "PFqYV",
  "headerOne": "mprt- PFqYV",
  "headerTwo": "pEp3- PFqYV",
  "headerThree": "_3swDb PFqYV",
  "headerFour": "onRny PFqYV",
  "headerFive": "_23ldv PFqYV",
  "headerSix": "uxISo PFqYV",
  "child": "NsX9Q"
};
export {
  heading_default as default
};
//# sourceMappingURL=heading-scss.js.map
